import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useI18n } from '../lib/i18n'
import { track } from '../lib/track'

/**
 * /pricing — the offer a business owner sees before buying (Chairman 2026-09-11:
 * "build it day 1"). €19/month per business, 30-day free trial, NO card at
 * signup (RentingPilot LOCKED pattern — card collected before day 30). QR-MENU
 * is the first real product; its trial signup is live at menu.myclienta.com.
 */
// Money path: Stripe Checkout (30-day trial, NO card) -> /welcome -> QR-MENU onboarding.
const QR_MENU_TRIAL = '/api/billing/checkout?product=qr-menu'

export default function Pricing() {
  useEffect(() => {
    track('pricing_view')
  }, [])
  const { t } = useI18n()
  return (
    <section className="section py-12 max-w-3xl">
      <header className="text-center">
        <span className="inline-flex rounded-full border border-[#dfe5ef] bg-white px-4 py-1.5 text-xs font-black uppercase tracking-wider text-[#65728d] shadow-sm">
          {t('Simple pricing')}
        </span>
        <h1 className="mt-4 text-3xl sm:text-5xl font-black tracking-tight text-[#071023]">
          {t('One price. Everything included.')}
        </h1>
        <p className="mt-3 text-[#65728d] font-medium max-w-xl mx-auto">
          {t('Try it free for 30 days. No credit card to start. Keep it only if it works for your business.')}
        </p>
      </header>

      <div className="mt-10 rounded-3xl border border-[#dfe5ef] bg-white p-8 shadow-lg sm:p-10">
        <div className="flex items-end justify-center gap-1">
          <span className="text-5xl font-black text-[#071023]">€19</span>
          <span className="mb-1.5 text-lg font-bold text-[#8b96ab]">{t('/ month')}</span>
        </div>
        <p className="mt-2 text-center text-sm font-semibold text-emerald-600">
          {t('30-day free trial · no card at signup')}
        </p>

        <ul className="mt-8 space-y-3">
          {[
            t('Your own live product in minutes — no setup fee'),
            t('Works on any phone, no app to install'),
            t('Available in 6 languages'),
            t('Cancel anytime — you are never locked in'),
            t('We set everything up for you — zero technical work'),
          ].map((line) => (
            <li key={line} className="flex items-start gap-3 text-[#3d4a63] font-medium">
              <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-emerald-100 text-xs text-emerald-700">✓</span>
              {line}
            </li>
          ))}
        </ul>

        <a
          href={QR_MENU_TRIAL}
          rel="nofollow"
          onClick={() => track('checkout_start', { product: 'qr-menu' })}
          className="mt-8 block rounded-xl bg-[#ffb21f] px-6 py-4 text-center text-base font-black text-[#211300] shadow-lg shadow-amber-300/40 transition hover:-translate-y-0.5 hover:bg-[#ffa40b]"
        >
          {t('Start your 30-day free trial →')}
        </a>
        <p className="mt-3 text-center text-xs text-[#8b96ab]">
          {t('You will only be asked for a card before the trial ends. No charge today.')}
        </p>
      </div>

      {/* Partner path — the second engine */}
      <div className="mt-8 rounded-2xl border border-[#dfe5ef] bg-[#f7f9fd] p-6 text-center">
        <h2 className="text-lg font-black text-[#071023]">{t('Want to earn instead of buy?')}</h2>
        <p className="mt-1.5 text-sm font-medium text-[#65728d]">
          {t('Join free as a partner: show these demos to local businesses and earn €30 setup + 30% recurring for 6 months on every signup.')}
        </p>
        <Link
          to="/how-it-works"
          className="mt-4 inline-flex rounded-xl border border-[#071023] px-5 py-3 text-sm font-black text-[#071023] transition hover:bg-[#071023] hover:text-white"
        >
          {t('See how partners earn →')}
        </Link>
      </div>

      <p className="mt-8 text-center text-sm text-[#8b96ab]">
        {t('Questions?')}{' '}
        <a href="mailto:hello@myclienta.com" className="font-semibold text-[#071023] underline">
          hello@myclienta.com
        </a>
      </p>
    </section>
  )
}
